import VueRouter from 'vue-router'
import { getClientId } from './lib/client'
import routes from './routes'

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  //document.title = to?.meta?.title;
  next()
})

router.beforeEach((to, from, next) => {
  getClientId()
    .then(clientId => {
      to.params.clientId = clientId
      next()
    })
    .catch(next)
})

export default router
